import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScoreboardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"scoreboard"}/>
}
